export enum Permission {
  // Tenant
  DeleteTenant = 'deleteTenant',
  DeleteTenantSelf = 'deleteTenantSelf',
  GetTenant = 'getTenant',
  GetTenants = 'getTenants',

  // Admin Settings
  GetTenantAdminSettings = 'getTenantAdminSettings',
  UpdateAdminPassword = 'updateAdminPassword',
  UpdateAdminSettings = 'updateAdminSettings',

  // Audit Events
  GetAuditEvents = 'getAuditEvents',

  // IDPs
  CreateIdp = 'createIdp',
  GetIdp = 'getIdp',
  DeleteIdp = 'deleteIdp',
  UpdateIdp = 'updateIdp',

  // Instance
  GetInstances = 'getInstances',
  CreateInstance = 'createInstance',
  CreateNewCE = 'createNewCE',
  DeleteInstance = 'deleteInstance',
  UpdateInstance = 'updateInstance',
  DeactivateInstance = 'deactivateInstance',
  ReactivateInstance = 'reactivateInstance',
  RemoveDeletedInstance = 'removeDeletedInstance',

  // Licenses
  DownloadLicense = 'downloadLicense',
  DeleteLicense = 'deleteLicense',

  // Artifacts
  AccessArtifacts = 'accessArtifacts',

  // Support Case Management
  GetCaseGrants = 'getCaseGrants',
  ManageCaseGrants = 'manageCaseGrants',
}
